import {
  DynamicAttributeBannerModel,
  DynamicAttributeOptionModel,
  DynamicAttributeModel,
  DynamicAttributeBannerDto,
  DynamicAttributeDto,
  DynamicAttributeOptionDto,
} from '../types/dynamic-attribute'
import { SelectionSource } from '../constants'
import { DynamicAttribute, ItemAttributeDto } from '../types'

export const transformDynamicAttributeBanner = ({
  message,
  faq,
}: DynamicAttributeBannerDto): DynamicAttributeBannerModel => ({
  message,
  faq: faq
    ? {
        id: faq.id,
        text: faq.text,
      }
    : null,
})

export const transformDynamicAttributeOptions = (
  dynamicAttributeOptions: Array<DynamicAttributeOptionDto> | undefined,
): Array<DynamicAttributeOptionModel> => {
  if (!dynamicAttributeOptions?.length) return []

  return dynamicAttributeOptions.map(
    ({
      id,
      title,
      type,
      options,
      description,
    }: DynamicAttributeOptionDto): DynamicAttributeOptionModel => ({
      id,
      title,
      type,
      description,
      source: SelectionSource.Default,
      options: transformDynamicAttributeOptions(options),
    }),
  )
}

export const transformDynamicAttribute = ({
  id,
  title,
  code,
  description,
  placeholder,
  display_type,
  selection_type,
  required,
  selection_limit,
  banner,
  options,
}: DynamicAttributeDto): DynamicAttributeModel => ({
  id,
  title,
  code,
  description,
  placeholder,
  displayType: display_type,
  selectionType: selection_type,
  required,
  selectionLimit: selection_limit,
  banner: banner ? transformDynamicAttributeBanner(banner) : null,
  options: transformDynamicAttributeOptions(options),
})

export const transformDynamicAttributesToModel = (
  dynamicAttributes: Array<DynamicAttributeDto>,
): Array<DynamicAttributeModel> => dynamicAttributes.map(transformDynamicAttribute)

export const transformDynamicAttributes = (
  attributes: Array<ItemAttributeDto> | undefined,
): Array<DynamicAttribute> =>
  attributes?.map(({ code, ids }) => ({ field: code, value: ids })) || []
